<template>
    <span class="m-br">
        <br v-if="m" class="except-pc" />
        <br v-else class="pc-only" />
    </span>
</template>

<script>
export default {
    props: {
        m: Boolean,
    },
};
</script>

<style lang="scss" scoped>
.except-pc {
    @media screen and (min-width: 361px) {
        display: none !important;
    }
}
.pc-only {
    @media screen and (max-width: 360px) {
        display: none !important;
    }
}
</style>
